import { useRef, useState } from "react";
import { Button, Input } from "reactstrap";
import { toast } from "react-toastify";
import { uploadCertificateLogoAPI } from "../../../apiConfig/apiCall";

const MIN_DIMENSION = 130;

const ImageUploader = ({ ssoId, modalHandler, refreshClientList }) => {
    const imgRef = useRef(null);
    const [imgSrc, setImgSrc] = useState("");
    const [error, setError] = useState("");

    const onSelectFile = (e) => {
        const file = e.target.files?.[0];
        if (!file) return;

        const reader = new FileReader();
        reader.addEventListener("load", () => {
            const imageElement = new Image();
            const imageUrl = reader.result?.toString() || "";
            imageElement.src = imageUrl;

            imageElement.addEventListener("load", (e) => {
                const { naturalWidth, naturalHeight } = e.currentTarget;
                if (naturalWidth < MIN_DIMENSION || naturalHeight < MIN_DIMENSION) {
                    setError("Image must be at least 130 x 130 pixels.");
                    return setImgSrc("");
                }
                if (error) setError("");
            });

            setImgSrc(imageUrl);
        });
        reader.readAsDataURL(file);
    };

    const handleUploadImage = async () => {
        try {
            const response = await fetch(imgSrc);
            const blob = await response.blob();

            const file = new File([blob], "uploaded-image.png", { type: "image/png" });
            const formData = new FormData();
            formData.append("file", file);

            const apiResponse = await uploadCertificateLogoAPI(ssoId, formData);
            console.log(apiResponse)
            if (apiResponse.status === 200) {
                toast.success(apiResponse.data.message);
                modalHandler(false);
                refreshClientList();
            }
        } catch (error) {
            console.error("Error uploading image:", error);
        }
    };

    return (
        <>
            <Input
                className="mb-2"
                type="file"
                accept="image/*"
                onChange={onSelectFile}
            />
            {error && <p className="text-danger">{error}</p>}
            {imgSrc && (
                <>
                    <div className="d-flex justify-content-center mb-3">
                        <img
                            ref={imgRef}
                            src={imgSrc}
                            alt="Preview"
                            style={{ maxWidth: "100%", maxHeight: "70vh" }}
                        />
                    </div>
                    <Button
                        color="primary"
                        onClick={handleUploadImage}
                    >
                        Upload Image
                    </Button>
                </>
            )}
        </>
    );
};

export default ImageUploader;